export default __webpack_public_path__ + "static/media/startup.a9274ae7.svg";